module.exports = __webpack_public_path__ + "media/seedance-demo.beda2ff0.mp4";